import { gql } from '@/__generated__';

/**
 * Cerrar el ticket abierto del device. No lleva payload: la fila se encuentra por `deviceId` +
 * `closed_at IS NULL` y la fecha de cierre sale de la DB (AMARU-736). Antes el frontend devolvía
 * `ticketId` y `ticketTimestamp` solo para satisfacer la firma de `updateDgaTicket`.
 *
 * La selección pide igual `dga { ticket }` para que la caché de Apollo se entere de que ya no hay
 * ticket vigente: el resolver devuelve `null` y la vista del modal cambia sin refetch manual.
 */
const CLOSE_DGA_TICKET = gql(`#graphql
  mutation CloseDgaTicket($deviceId: ID!) {
    closeDgaTicket(deviceId: $deviceId) {
      id
      dga {
        id
        ticket {
          id
          timestamp
          description
        }
      }
    }
  }
`);

export default CLOSE_DGA_TICKET;
